export const CREATE_SUBSCRIBER= 'CREATE_SUBSCRIBER';
export const CREATE_SUBSCRIBER_ERR = 'CREATE_SUBSCRIBER_ERR';